var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E5F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.99927,
    y: 3.25,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#66DAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2164 15.6994C16.4104 18.2985 13.4031 20 9.99845 20C6.59375 20 3.58646 18.2985 1.78052 15.6994C4.14089 14.1508 6.96448 13.25 9.99845 13.25C13.0324 13.25 15.856 14.1508 18.2164 15.6994Z",
    fill: "#66DAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/UserAvatar.8220f8204983d1d362f77e3c52333c5c.svg";
export { ForwardRef as ReactComponent };